import React, { Component } from "react";
import { useState, useEffect } from 'react'
import store from "@/redux/store";
import { open, close, setPos } from '@/reducers/Window'
import { useTranslation, withTranslation, Trans } from "react-i18next";
import { WINDOW } from "@/actions/globalConst";

export function IntroPanel({...props}) {
    const { t, i18n, ready } = useTranslation();
    const {txtKey} = props;
    const classNames = ((props?.className) ? props?.className : 'sm:w-0 sm:flex-1');
    const getLanguageTxt = ($key) => {
        let txt = t("views."+txtKey+"."+$key);
        return txt;
    }

    const editViewTxt = (event) => {
        let translateObj = t("views."+txtKey, { returnObjects: true });
        let txt = ( (typeof translateObj == 'object') ? translateObj : {h1:txtKey, p:''} );

        store.dispatch( open({...WINDOW.CHANGE_LANGUAGE_LABELS, data:{key: txtKey, txtKeys: txt} } ) );
        

        return false;
    }

    return (
        <>
        <div className={classNames} onClickCapture={(event) => editViewTxt(event)}>
            <h3 className="text-base font-semibold leading-6 text-gray-900">{getLanguageTxt('h1')}</h3>
            <p className="mt-2 max-w-4xl text-sm text-gray-500"
            dangerouslySetInnerHTML={{__html: getLanguageTxt('p')}} />
        </div>
        </>
    )
}
